(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/set-branding/assets/javascripts/template-brand.js') >= 0) return;  svs.modules.push('/components/tipsen/set-branding/assets/javascripts/template-brand.js');
"use strict";

const {
  useEffect
} = React;
const {
  template
} = svs.core;
const {
  data
} = svs.tipsen;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  useBranding
} = svs.components.tipsen.hooks;
const getSelectedIndex = items => {
  const slicedItems = items.slice(0);
  slicedItems.sort((a, b) => b.url.length - a.url.length);
  let selectedIndex = 0;
  for (let i = 0; i < slicedItems.length; ++i) {
    if (slicedItems[i].url.length > location.pathname.length) {
      continue;
    }
    if (location.pathname.startsWith(slicedItems[i].url)) {
      selectedIndex = i;
      break;
    }
  }
  return items.indexOf(slicedItems[selectedIndex]);
};
const TemplateBrand = _ref => {
  let {
    draw,
    drawCompetitionId,
    drawId
  } = _ref;
  const brandingList = useBranding(drawId, drawCompetitionId);
  const definition = useDefinition();
  const currentDraw = useCurrentDraw();
  const brandingByDraw = definition.getBrandLogoByDraw(currentDraw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const {
    menuItems
  } = data;
  const selectedIndex = getSelectedIndex(menuItems);
  const selectedMenuItem = menuItems[selectedIndex];
  const drawToUse = draw || currentDraw;
  useEffect(() => {
    if (!Array.isArray(branding) || !branding.length) {
      return;
    }
    if (drawToUse) {
      var _selectedMenuItem$alt;
      const displayName = definition.getDisplayNameByDraw(drawToUse);
      const brandLogo = definition.getBrandLogoByDraw(drawToUse);
      template.updateConfig({
        tabs: {
          branding: "".concat(branding, "-main-nav")
        },
        headerClass: "header-".concat(branding),
        title: {
          row1: {
            brand: brandLogo,
            text: displayName,
            alt: selectedMenuItem && (_selectedMenuItem$alt = selectedMenuItem.alt) !== null && _selectedMenuItem$alt !== void 0 && _selectedMenuItem$alt.length ? selectedMenuItem.alt : displayName
          }
        }
      });
    }
    document.querySelector('html').classList.add(branding);
    return () => {
      document.querySelector('html').classList.remove(branding);
    };
  }, [branding, definition, drawToUse, selectedMenuItem]);
  return null;
};
TemplateBrand.propTypes = {
  draw: PropTypes.object,
  drawCompetitionId: PropTypes.number,
  drawId: PropTypes.string
};
setGlobal('svs.components.tipsen.setBranding.TemplateBrand', TemplateBrand);

 })(window);